<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.employeeProfile.employeeProfile') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('administration.employee.employeeProfile.employeeProfile'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-flex">
            <ts-button v-if="!is_hris" color="info" outline @click="$router.push({ name: 'employee-create' })">{{
              $t('employee.addNew') }}</ts-button>
            <div class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap mr-2">
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="front" :value="'front'" />
                <label for="front">
                  {{ $t('administration.employee.employeeProfile.front') }}
                </label>
              </div>
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="back" :value="'back'" />
                <label for="back">
                  {{ $t('administration.employee.employeeProfile.back') }}
                </label>
              </div>
              <!-- Old Preview Card  -->
              <ts-button v-if="false" class="btn-sm ml-2 mr-3" :disabled="!checkedEmp.length > 0" outline
                color="primary" @click="previewCard('simple')">
                {{ $t('administration.employee.employeeProfile.previewCard') }}
              </ts-button>
            </div>
            <a-modal v-model="dateCard" centered :title="$t('expireDate')" @ok="handleDateOk" :cancelText="$t('cancel')"
              :okText="$t('ok')" width="20%">
              <DatePicker type="date" v-model="formattedDate" style="width:100%" placeholder="DD MMM YYYY"
                format="dd MMM yyyy" @on-change="date => (this.formattedDate = date)">
              </DatePicker>
            </a-modal>
            <!-- New Preview Card -->
            <div class="ts-mr-2" v-if="true">
              <b-dropdown dropdown :text="$t(
                'school.academic.operation.profile_mgt.studentProfile.previewCard'
              )
                " variant="primary">
                <b-dropdown-item :disabled="!checkedEmp.length > 0" href="#" @click="() => handleCardClick('simple')">
                  <i class="fas fa-print"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.simplePrinter'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item :disabled="!checkedEmp.length > 0" href="#" @click="() => handleCardClick('pro')">
                  <i class="fas fa-id-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.proPrinter'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item :disabled="!checkedEmp.length > 0" href="#" @click="previewCard('image')">
                  <i class="fas fa-id-card"></i>
                  {{
                    $t('administration.employee.employeeProfile.imageDownload')
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <b-dropdown dropdown :text="$t('administration.employee.employeeProfile.exportExcel')"
              variant="outline-success" :waiting="exporting">
              <b-dropdown-item :disabled="!checkedEmp.length > 0" href="#" @click="exportExcelSelectedEmployee">
                <i class="fas fa-check-square"></i>
                {{
                  $t('administration.employee.employeeProfile.selectedEmployee')
                }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="exportExcelAllTeacher">
                <i class="fas fa-users"></i>
                {{ $t('administration.employee.employeeProfile.allEmployee') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="ts-flex-grow"></div>
          <select class="form-control" style="width: 120px" v-model="status">
            <option v-for="status in statuses" :value="status">
              {{ status }}
            </option>
          </select>
          <div class="ml-2 mr-2">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" />
          </div>
          <ts-button outline v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </ts-button>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table :columns="columns" :data="resources" :loading="loading" max-height="700" stripe highlight-row
            size="small" ref="selection" @on-select="onSelectCheck" @on-select-cancel="onSelectUncheck"
            @on-select-all="onSelectAllCheck" @on-select-all-cancel="onSelectAllUncheck">
            <template slot-scope="{ row }" slot="photo">
              <img class="height-40 ts-rounded" v-lazy="{
                src: photoEmployee(row),
                error: onError(row),
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }" />
            </template>
            <template slot-scope="{ row }" slot="branch">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="emp_id">
              {{ row.emp_id }}
            </template>
            <template slot-scope="{ row }" slot="name_kh">
              {{ row.name_kh }}
            </template>
            <template slot-scope="{ row }" slot="name_en">
              {{ row.name_en }}
            </template>
            <template slot-scope="{ row }" slot="gender">
              {{ row.gender ? (row.gender == 1 ? 'Male' : 'Female') : '_' }}
            </template>
            <template slot-scope="{ row }" slot="date_of_birth">
              {{ row.date_of_birth }}
            </template>
            <template slot-scope="{ row }" slot="phone_number_1">
              {{ row.phone_number_1 }}
            </template>
            <template slot-scope="{ row }" slot="pos_name_en">
              {{
                row.position !== null
                  ? $store.getters.limitStringShow(row.position.pos_name_en, 25)
                  : ''
              }}
            </template>
            <template slot-scope="{ row }" slot="shift_name">
              {{
                row.shift
                  ? row.shift.shift_name + ' (' + row.shift.shift_type + ') '
                  : ''
              }}
            </template>
            <template slot-scope="{ row }" slot="status">
              <span class="badge badge-success" v-if="row.status == 'Active'">{{
                $t('employee.active')
              }}</span>
              <span class="badge badge-danger" v-if="row.status == 'Resigned'">{{ $t('employee.resigned') }}</span>
              <span class="badge badge-warning" v-if="row.status == 'Terminated'">{{ $t('employee.terminated') }}</span>
              <span class="badge badge-info" v-if="row.status == 'Suspend'">{{
                $t('employee.suspend')
              }}</span>
              <span class="badge badge-secondary" v-if="row.status == 'Cancelled'">{{ $t('employee.cancelled') }}</span>
            </template>
            <template slot-scope="{ row }" slot="created_by">
              {{
                row.created_by
                  ? row.created_by.employee
                    ? row.created_by.employee.name_en
                    : row.created_by.loginname
                  : ''
              }}
            </template>
            <template slot-scope="{ row }" slot="created_date">
              {{ row.created_date }}
            </template>
            <template slot-scope="{ row }" slot="card_print_counter">
              <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_increase')" :ok-text="$t('yes')"
                :cancel-text="$t('no')" @confirm="increaseCounter(row)">
                <a href="#" class="btn ts-bg-teal-500 ts-text-white btn-circle btn-xs">
                  <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                  <span v-else>
                    {{ row.card_print_counter ? row.card_print_counter : 0 }}
                  </span>
                </a>
              </a-popconfirm>
            </template>
            <template slot-scope="{ row }" slot="action">
              <a href="#" title="Transfer" class="mr-2 text-primary" @click.prevent="transfer(row)" v-if="!is_hris">
                <i class="fas fa-exchange-alt"></i>
              </a>
              <a href="#" title="Show" class="mr-2 text-info" @click.prevent="show(row)">
                <i class="fas fa-eye"></i>
              </a>
              <a href="#" title="Edit" class="mr-2 text-primary" @click.prevent="edit(row)" v-if="!is_hris">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" title="Delete" class="text-danger mr-2" @click.prevent="destroy(row)"
                :disabled="row._deleting" v-if="!is_hris">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
              <Dropdown trigger="click" v-tooltip="$t(
                'school.academic.operation.profile_mgt.studentProfile.card'
              )
                " style="margin-left: 10px" @on-click="name => card(row, name)">
                <i class="fas fa-id-card"></i>
                <DropdownMenu slot="list">
                  <DropdownItem name="front"><i class="fas fa-address-card"></i>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.frontCard'
                      )
                    }}</DropdownItem>
                  <DropdownItem name="back"><i class="far fa-credit-card"></i>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.backCard'
                      )
                    }}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <!-- drawer -->
    <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
      @close="() => (visible = false)" :zIndex="1020" width="300px">
      <div style="font-size: 12px">
        <div class="row">
          <div class="form-group">
            <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
              :filterOption="(input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
            </a-select>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">Card Activation</legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="id_card_activated" type="radio" id="activated" :value="'yes'" />
              <label for="activated"> Activated </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="id_card_activated" type="radio" id="no_activated" :value="'no'" />
              <label for="no_activated"> Not Yet Activate </label>
            </div>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">Photo Upload</legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="photo_exists" type="radio" id="uploaded" :value="'yes'" />
              <label for="uploaded"> Uploaded </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="photo_exists" type="radio" id="no_upload" :value="'no'" />
              <label for="no_upload"> Not Yet Upload </label>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { debounce, trim } from 'lodash'
import { mapState } from 'vuex'
import PreviewCard from './preview-card'
import * as FileDownload from 'downloadjs'
import TransferComponent from './transfer.vue'
import DownloadTable from './component/download-table.vue'
import moment from 'moment'
export default {
  name: 'employee',
  components: { TransferComponent },
  data() {
    return {
      loading: false,
      exporting: false,
      side: 'front',
      checkedEmp: [],
      visible: false,
      branchs: [],
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      validDate: moment()
        .endOf('year')
        .format('DD MMM YYYY'),
      dateCard: false,
      cardType: ''
    }
  },

  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResourceBeforeCreate()
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('employee', ['resources', 'pagination', 'statuses']),
    search: {
      get() {
        return this.$store.state.employee.search
      },
      set(newValue) {
        this.$store.commit('employee/SET_SEARCH', newValue)
        this.$store.commit('employee/RESET_CURRENT_PAGE')
      }
    },
    id_card_activated: {
      get() {
        return this.$store.state.employee.id_card_activated
      },
      set(newValue) {
        this.$store.commit('employee/SET_ID_CARD_ACTIVATED', newValue)
      }
    },
    photo_exists: {
      get() {
        return this.$store.state.employee.photo_exists
      },
      set(newValue) {
        this.$store.commit('employee/SET_PHOTO_EXISTS', newValue)
      }
    },
    status: {
      get() {
        return this.$store.state.employee.status
      },
      set(newValue) {
        this.$store.commit('employee/SET_STATUS', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.employee.branch_id
      },
      set(newValue) {
        this.$store.commit('employee/SET_BRANCH_ID', newValue)
      }
    },
    formattedDate: {
      get() {
        return this.validDate
      },
      set(value) {
        this.validDate = moment(value).isValid()
          ? moment(value).format('DD MMM YYYY')
          : value
      }
    },
    is_hris() {
      if (this.$store.state.authUser.company) {
        return this.$store.state.authUser.company.is_hris
      }
      return false
    },
    columns() {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t('employee.photo'),
          minWidth: 80,
          slot: 'photo'
        },
        {
          title: this.$t('employee.branch'),
          minWidth: 120,
          slot: 'branch'
        },
        {
          title: this.$t('employee.id'),
          minWidth: 120,
          slot: 'emp_id'
        },
        {
          title: this.$t('employee.nameKh'),
          minWidth: 130,
          slot: 'name_kh'
        },
        {
          title: this.$t('employee.nameEn'),
          minWidth: 130,
          slot: 'name_en'
        },
        {
          title: this.$t('employee.gender'),
          minWidth: 120,
          align: 'center',
          slot: 'gender'
        },
        {
          title: this.$t('employee.dateofbirth'),
          minWidth: 120,
          align: 'center',
          slot: 'date_of_birth'
        },
        {
          title: this.$t('employee.phone'),
          minWidth: 120,
          slot: 'phone_number_1'
        },
        {
          title: this.$t('employee.position'),
          minWidth: 120,
          align: 'center',
          slot: 'pos_name_en'
        },
        {
          title: this.$t('employee.shift'),
          minWidth: 120,
          slot: 'shift_name'
        },
        {
          title: this.$t('employee.status'),
          minWidth: 120,
          align: 'center',
          slot: 'status'
        },
        {
          title: this.$t('employee.createdBy'),
          minWidth: 120,
          align: 'center',
          slot: 'created_by'
        },
        {
          title: this.$t('employee.createdDate'),
          minWidth: 120,
          slot: 'created_date'
        },
        {
          title: this.$t('employee.cardCounter'),
          minWidth: 120,
          align: 'center',
          slot: 'card_print_counter'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 200
        }
      ]
    }
  },
  methods: {
    photoEmployee(record) {
      if (record.photo) {
        return record.photo
      }

      return record.gender == 1
        ? require('@/assets/staff-default-man.png')
        : require('@/assets/staff-default-women.png')
    },
    onError(record) {
      event
        ? (event.target.src =
          record.gender == 1 ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    onSelectCheck(record) {
      this.setEmployeeIdListSelected(record)
    },
    onSelectUncheck(record) {
      this.setEmployeeIdListSelected(record)
    },
    onSelectAllCheck(record) {
      this.setStudentListSelected(record)
    },
    onSelectAllCheck(record) {
      this.setEmployeeIdListSelected(record)
    },
    onSelectAllUncheck(record) {
      this.setEmployeeIdListSelected(record)
    },
    handleSelectAll(status) {
      this.$refs.selection.selectAll(status)
    },
    setEmployeeIdListSelected(records) {
      this.checkedEmp = []
      if (records.length > 0) {
        records.map(row => {
          this.checkedEmp.push(row.staff_id)
        })
      }
    },
    increaseCounter(record) {
      record._deleting = true
      this.$store
        .dispatch('employee/increasePrinterCardCounter', record.staff_id)
        .then(response => {
          record.card_print_counter =
            parseInt(record.card_print_counter, 10) + 1
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    fetchResourceBeforeCreate() {
      this.$store
        .dispatch('employee/dataBeforeCreate')
        .then(() => { })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'employee/fetch',
          Object.assign(
            {
              page: this.pagination.currentPage
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('employee/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'employee-edit',
        params: { id: record.staff_id }
      })
    },
    show(record) {
      this.$store.commit('employee/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'employee-show',
        params: { id: record.staff_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('employee/destroy', record.staff_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    checkItem(value) {
      this.checkedEmp = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedEmp.push(element.staff_id)
        })
      }
    },
    handleCardClick(cardType) {
      this.cardType = cardType
      // Check if company_id is 3
      const isSpecialCompany =
        this.$store.state.authUser.company &&
        this.$store.state.authUser.company.company_id === 3

      if (isSpecialCompany) {
        // For company_id 3(hilltop), show date popup for both front and back
        if (cardType === 'pro') {
          this.dateCard = true
        } else {
          this.dateCard = false
          this.previewCard(cardType)
        }
      } else {
        this.dateCard = false
        this.previewCard(cardType)
      }
    },
    handleDateOk() {
      this.previewCard(this.cardType)
      this.dateCard = false
    },

    previewCard(type) {
      // Check if company_id is 3
      const isSpecialCompany =
        this.$store.state.authUser.company &&
        this.$store.state.authUser.company.company_id === 3

      // For non-special companies or when dateCard is false, use empty validDate
      const validDate = isSpecialCompany && this.dateCard ? this.validDate : ''

      if (type === 'image') {
        this.$modal.show(
          DownloadTable,
          {
            id_list: this.checkedEmp,
            side: this.side,
            type: type,
            valid_date: validDate
          },
          {
            height: 'auto',
            width: '70%',
            scrollable: true,
            draggable: '.form-header',
            clickToClose: false,
            classes: 'download-table-modal'
          }
        )
      } else {
        this.$modal.show(
          PreviewCard,
          {
            id_list: this.checkedEmp,
            side: this.side,
            type: type,
            valid_date: validDate
          },
          {
            height: 'auto',
            width: '70%',
            scrollable: true,
            draggable: '.form-header',
            clickToClose: false
          }
        )
      }
    },
    excel(record) {
      this.checkedEmp = []
      this.checkedEmp.push(record.staff_id)
      this.exportExcelSelectedEmployee()
      this.checkedEmp = []
    },
    exportExcelAllTeacher() {
      this.checkedEmp = []
      this.exportExcelSelectedEmployee()
    },
    exportExcelSelectedEmployee() {
      this.exporting = true
      this.$store
        .dispatch('employee/exportExcel', {
          staff_id: this.checkedEmp,
          branch_id: this.branch_id
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    },
    card(record, side) {
      this.checkedEmp = []
      this.checkedEmp.push(record.staff_id)
      this.side = side
      this.previewCard('simple')
      this.checkedEmp = []
    },
    photoEmp(record) {
      if (record.photo) {
        return record.photo
      }

      return record.gender == 1 ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event
        ? (event.target.src =
          record.gender == 1 ? this.manPhoto : this.womenPhoto)
        : ''
    },
    transfer(record) {
      this.$modal.show(
        TransferComponent,
        {
          value: record
        },
        {
          height: 'auto',
          scrollable: true,
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        branch_id: this.branch_id,
        id_card_activated: this.id_card_activated,
        status: this.status,
        photo_exists: this.photo_exists
      })
    }, 500),
    id_card_activated: debounce(function (id_card_activated) {
      this.fetchData({
        id_card_activated,
        branch_id: this.branch_id,
        status: this.status,
        photo_exists: this.photo_exists
      })
    }, 500),
    photo_exists: debounce(function (photo_exists) {
      this.fetchData({
        photo_exists,
        status: this.status,
        branch_id: this.branch_id,
        id_card_activated: this.id_card_activated
      })
    }, 500),
    status: debounce(function (status) {
      this.fetchData({
        status,
        branch_id: this.branch_id,
        id_card_activated: this.id_card_activated,
        photo_exists: this.photo_exists
      })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'employee-create') {
      this.$store.commit('employee/RESET_STATE')
      this.$store.commit('employee/SET_POSITIONS', [])
      this.$store.commit('employee/SET_STATUSES', [])
      this.$store.commit('employee/SET_PROVINCES', [])
      this.$store.commit('employee/SET_DISTRICTS', [])
      this.$store.commit('employee/SET_COMMUNES', [])
      this.$store.commit('employee/SET_VILLAGES', [])
      this.$store.commit('employee/SET_ID_TYPES', [])
      this.$store.commit('employee/SET_SPOUSE_OCCUPATIONS', [])
      this.$store.commit('employee/SET_DIVISIONS', [])
      this.$store.commit('employee/SET_DEPARTMENTS', [])
      this.$store.commit('employee/SET_EMPLOYEES', [])
      this.$store.commit('employee/SET_SHIFTS', [])
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: #ffff;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}

.table-status {
  display: table;
  border-collapse: collapse;
  border: none;
}

.table-status td {
  padding: 2px 4px;
  border-top: none !important;
  font-size: 10px;
}

table.table-status .icon {
  visibility: hidden;
}

table.table-status tr:hover .icon {
  visibility: visible;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  border-color: #e2e7eb;
  padding: 8px 10px;
}

.external-student {
  border-color: hsl(214, 100%, 59%);
  border-width: 2px;
}

.ivu-table td {
  height: 2px;
  padding: 2px;
}

.download-table-modal {
  z-index: 1011;
}
</style>
